<advanced-search-header></advanced-search-header>

<form novalidate fxLayout="column" class="pr-32 pl-32 content-form">
  <!-- //LOADER -->
  <div class="spinner-container" *ngIf="(isLoading$ | async)">
    <custom-loader></custom-loader>
  </div>

  <!-- FALTA TOGGLE y no esta hecha la conexion a store boolean -->
  <mat-slide-toggle class="form-filter" [(ngModel)]="onlyOwnerSelected" name="onlyOwnerSelected">
    {{ 'ADMIN.MASTER.INSIGHTS.TOGGLE_FILTER' | pTranslate }}
  </mat-slide-toggle>

  <!-- CATEGORIAS -->
  <generic-cat-select-mini-v2
    class="form-filter"
    [selected]="{level4:categoriesSelected}"
    (onChange)="setCategories($event)"
    [levels]="[4]"
    [level4Config]="{ multiple: true, parentDependent: false, group: false }"
  ></generic-cat-select-mini-v2>

  <!-- STORE TAGS  -->
  <p class="form-filter title-filter">
    {{ 'PR.DECISIONS.PRICE_DECISIONS.ADVANCED_FILTER.TitleStoreTags' | pTranslate }}
  </p>
  <dinamic-tags-advanced-filter
    [tagsList]="storeTags"
    [activeTags]="storeTagsSelected"
    (dinamicTagsForm)="storeTagsSelected = $event"
    (resetTagsForm)="resetTags($event)"
  ></dinamic-tags-advanced-filter>

  <!-- TIENDAS/STORES -->

  <generic-lookup
    class="form-filter"
    [values]="stores"
    [selected]="storeSelected"
    (onChange)="storeSelected = $event"
    [multiple]="true"
    [required]="false"
    [itemSize]="4"
    [propValue]="'name'"
    placeholder=" {{ 'ADMIN.MASTER.INSIGHTS.STORES_FILTER' | pTranslate }}"
    [optionComponent]="customOptionStore"
  ></generic-lookup>
  <ng-template #customOptionStore let-option="option">
    <ng-container>{{option.code}} | {{ option.name }}</ng-container>
  </ng-template>

  <!-- FALTA ANTIGUEDAD store listo es dateForm dateFormSelected -->
  <mat-form-field class="form-filter">
    <mat-label>{{ 'ADMIN.MASTER.INSIGHTS.ANTIQUITY_FILTER' | pTranslate }}</mat-label>
    <input
      matInput
      [matDatepicker]="picker"
      placeholder="{{ 'ADMIN.MASTER.INSIGHTS.ANTIQUITY_FILTER' | pTranslate }}"
      [(ngModel)]="dateFormSelected"
      name="dateFormSelected"
    />
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>

  <!-- TIPOS -->

  <generic-lookup
    class="form-filter"
    [values]="types"
    [selected]="typeSelected"
    (onChange)="typeSelected = $event"
    [multiple]="true"
    [required]="false"
    [itemSize]="4"
    [propValue]="'type'"
    placeholder=" {{ 'ADMIN.MASTER.INSIGHTS.INSIGHTS_TYPE_FILTER' | pTranslate }}"
    [optionComponent]="customOptionType"
  ></generic-lookup>
  <ng-template #customOptionType let-option="option">
    <ng-container>{{ option.type }}</ng-container>
  </ng-template>
</form>

<advanced-search-footer (reset)="resetFilter()" (apply)="applyFilter()"></advanced-search-footer>
